import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from './config.service';
import { WithdrawalRequest } from '../model/finzy-flex/withdraw-money.model';

@Injectable()
export class WithdrawalService {
	private readonly httpClient: HttpClient;
	private readonly configService: ConfigService;

	constructor(httpClient: HttpClient, configService: ConfigService) {
		this.httpClient = httpClient;
		this.configService = configService;
	}

	public async getWithdrawalRequestsListByLenderId(lender_id: string): Promise<Array<WithdrawalRequest>> {
		const url = `${this.configService.baseUrl()}withdrawal/list?lenderId=${lender_id}`;
		return await this.httpClient.get<Array<WithdrawalRequest>>(url).toPromise();
	}

}
